<template>
  <div class="sino-account">
    <!-- 头部开始 -->
    <topPart ></topPart>
    <!-- 头部结束 -->
    <div class="my-content">
      <div class="account-item">
        <div class="item-icon">
          <img src="@/images/sj.png" alt />
        </div>
        <div class="item-content" @click="openBindPhone">
          <div class="title">绑定手机号</div>
          <div class="hint">为了您的账户安全，请点击及时绑定手机</div>
        </div>
        <div class="item-arrow">
          <i class="cubeic-arrow"></i>
        </div>
      </div>
      <div class="account-item">
        <div class="item-icon">
          <img src="@/images/mm.png" alt />
        </div>
        <div class="item-content" @click="setPwd">
          <div class="title">设置登录密码</div>
          <div class="hint">请点击此处设置密码</div>
        </div>
        <div class="item-arrow">
          <i class="cubeic-arrow"></i>
        </div>
      </div>
      <div class="account-item">
        <div class="item-icon">
          <img src="@/images/ry.png" alt />
        </div>
        <div class="item-content" @click="openPersional">
          <div class="title">个人信息</div>
          <div class="hint">修改个人基本信息</div>
        </div>
        <div class="item-arrow">
          <i class="cubeic-arrow"></i>
        </div>
      </div>
      <!-- 地址管理开始 -->
      <div class="account-item">
        <div class="item-icon">
          <img src="@/images/address.png" alt />
        </div>
        <div class="item-content" @click="toAddress">
          <div class="title">地址管理</div>
          <div class="hint">修改地址信息</div>
        </div>
        <div class="item-arrow">
          <i class="cubeic-arrow"></i>
        </div>
      </div>
      <!-- 地址管理结束 -->

      <div class="sion-btn" @click="out">退出登录</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { mapMutations } from "vuex";
import { userLogout, delCookie } from "@/common/api";
import topPart from "../../components/topPart";

export default {
  components: {
    topPart
  },
  data() {
    return {
      currentBaseInfo: {}
    };
  },
  mounted() {
    this.currentBaseInfo = JSON.parse(localStorage.getItem("loginInfo"));
  },
  // beforeRouteLeave(to, from, next) {
  //   if (to.name === "login") {
  //     next();
  //   } else {
  //     next(); // 注意：这边next必须要写
  //   }
  // },
  methods: {
    ...mapMutations(["setLoginInfo", "changeLogin"]),
    openPersional() {
      this.$router.push("/personalInfo");
    },
    out() {
      this.$createDialog({
        type: "confirm",
        title: "提示",
        content: "是否退出？",
        icon: "cubeic-alert",
        confirmBtn: {
          text: "退出",
          active: true,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          userLogout({
            sessionId: this.currentBaseInfo.sessionId
          }).then(res => {
            if (res.code == 200) {
              this.$store.commit("changeLogin", "0");
              this.setLoginInfo([]);
              localStorage.setItem("code", "");
              let appId = localStorage.getItem("appId");
              localStorage.clear();
              localStorage.removeItem("loginInfo");
              localStorage.removeItem("loginToken");
              localStorage.setItem("appId", appId);
              delCookie("sessionId");
              location.reload();
              this.$router.push("/login");
            } else {
              toast(this, res.message, "error");
            }
            // this.$nextTick(() => {
            //   this.$router.push("/login");
            // });
          });
        }
      }).show();
    },
    openBindPhone() {
      this.$router.push("/bindPhone");
    },
    setPwd() {
      this.$router.push("/setPassword");
    },
    // 跳转至--地址管理
    toAddress() {
      this.$router.push("/addressList");
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/index.styl';

.sino-account {
  height: 100%;
}
</style>